module.exports = __webpack_public_path__ + "static/img/sign-blue.3026e3c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/sign-blue.jpg
// module id = 17Si
// module chunks = 9